// import React, { useEffect, useState } from "react";
// import {
//   Autocomplete,
//   Button,
//   Grid,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   IconButton,
//   Typography,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import axios from "axios";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";

// const OutletStatus = ({ onSubmit, onCancel, closedStatus, outletId }) => {
//   const dispatch = useDispatch();
//   const [mainCatData, setMainCatData] = useState([]); // State for main categories
//   const [selectedCategory, setSelectedCategory] = useState(null); // State for selected category
//   const [isLoader, setIsLoader] = useState(false); // Loader state
//   const [openConfirm, setOpenConfirm] = useState(false); // State for confirmation dialog

//   // Fetch main categories from the API
//   const getMainCatData = () => {
//     setIsLoader(true);
//     axios
//       .get("/v1/categories")
//       .then((res) => {
//         setMainCatData(res.data);
//         setIsLoader(false);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//         setIsLoader(false);
//       });
//   };

//   // Handle category selection
//   const handleCategoryChange = (event, value) => {
//     setSelectedCategory(value);
//     if (value) {
//       setOpenConfirm(true); // Open confirmation dialog upon selection
//     }
//   };

//   // Handle confirmation
//   const handleConfirm = async () => {
//     if (!selectedCategory || !outletId) {
//       console.error("Category or outlet ID is undefined.");
//       return;
//     }

//     const url = "/v1/barcode/deactivate/isclose";
//     const data = {
//       outlet_id: outletId,
//       is_closed: closedStatus[outletId] === 0 ? 0 : 0,
//       category_id: selectedCategory.id, // Include selected category ID in payload
//     };

//     try {
//       const response = await axios.post(url, data);
//       onSubmit(); // Call parent function if needed
//       onCancel(false); // Close the modal
//       setOpenConfirm(false)
//       dispatch(setSnackbar(true, "success", "Reset Count Successfully"));
//     } catch (error) {
//         const errorMessage = error.response?.data?.errors?.[0]?.message || 'An unexpected error occurred';
//         // setSnackbar(errorMessage);
//         dispatch(setSnackbar(true, "error", errorMessage));
// console.log(errorMessage,"errorMessage");

//         // onCancel(false); // Close the modal
//         // setOpenConfirm(false)
//     }
//   };

//   useEffect(() => {
//     getMainCatData();
//   }, []);

//   return (
//     <Grid className="bg-white p-5">
//     <Typography variant="body1"> Category </Typography>

//       <Autocomplete
//         id="mainCategory"
//         size="small"
//         options={[{id:0 ,category_name : "All"} , ...mainCatData]}

//         // options={mainCatData}
//         getOptionLabel={(option) => option.category_name}
//         value={selectedCategory}
//         onChange={handleCategoryChange}
//         onOpen={getMainCatData}
//         sx={{ width: 300 }} 
//         isOptionEqualToValue={(option, value) => option.id === value?.id}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             placeholder="Select Main Category"
//             error={!selectedCategory}
//             helperText={!selectedCategory ? "Please select a category" : ""}
//           />
//         )}
//       />

//       <Dialog
//         open={openConfirm}
//         onClose={() => setOpenConfirm(false)}
//       >
//         <DialogTitle>
//           Confirm Selection
//           <IconButton
//             aria-label="close"
//             onClick={() => setOpenConfirm(false)}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to select the category "{selectedCategory?.category_name}"?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
//           <Button
//             variant="contained"
//             sx={{ backgroundColor: 'red !important' }}
//             onClick={handleConfirm}
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Grid>
//   );
// };

// export default OutletStatus;
import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Grid,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";

const OutletStatus = ({ onSubmit, onCancel, closedStatus, outletId }) => {
  const dispatch = useDispatch();
  const [mainCatData, setMainCatData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
const [missedReactive, setMissedReactive] = useState(false);

  // Fetch main categories from the API
  const getMainCatData = () => {
    setIsLoader(true);
    axios
      .get("/v1/categories")
      .then((res) => {
        setMainCatData(res.data);
        setIsLoader(false);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
        setIsLoader(false);
      });
  };

  // Handle category selection
  const handleCategoryChange = (event, value) => {
    setSelectedCategory(value);
    if (value) {
      setOpenConfirm(true);
    }
  };

  // Handle confirmation
  const handleConfirm = async () => {
    if (!selectedCategory || !outletId) {
      console.error("Category or outlet ID is undefined.");
      return;
    }

    const url = "/v1/barcode/deactivate/isclose";
    const data = {
      outlet_id: outletId,
      is_closed: closedStatus[outletId] === 0 ? 0 : 0,
      category_id: selectedCategory.id,
      // is_missed_reactivate: missedReactive,
       is_missed_reactivate: missedReactive === "true",
    };

    try {
      const response = await axios.post(url, data);
      onSubmit();
      onCancel(false);
      setOpenConfirm(false);
      dispatch(setSnackbar(true, "success", "Reset Count Successfully"));
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors?.[0]?.message || "An unexpected error occurred";
      dispatch(setSnackbar(true, "error", errorMessage));
      console.log(errorMessage, "errorMessage");
    }
  };

  // Handle close action
  const handleClose = () => {
    setSelectedCategory(null);
    onCancel(false); // Close the modal or perform any other necessary action
  };

  useEffect(() => {
    getMainCatData();
  }, []);

  return (
    <Grid className="bg-white p-5">
      {/* <Typography variant="body1">Category</Typography> */}
  {/* Close Button */}
  <Grid container justifyContent="flex-end">
  
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</Grid>


      <Autocomplete
        id="mainCategory"
        size="small"
        options={[{ id: 0, category_name: "All" }, ...mainCatData]}
        getOptionLabel={(option) => option.category_name}
        value={selectedCategory}
        onChange={handleCategoryChange}
        onOpen={getMainCatData}
        sx={{ width: 300 }}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        renderInput={(params) => (
          <TextField
            {...params}
            label={"Category"}
            placeholder="Select Category"
            error={!selectedCategory}
            helperText={!selectedCategory ? "Please select a category" : ""}
          />
        )}
      />

    
      {/* <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>
          Confirm Selection
          <IconButton
            aria-label="close"
            onClick={() => setOpenConfirm(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to select the category "
            {selectedCategory?.category_name}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button>Missed Reactive</Button>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "red !important" }}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog> */}
<Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
  <DialogTitle>
    Confirm Selection
    <IconButton
      aria-label="close"
      onClick={() => setOpenConfirm(false)}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      Are you sure you want to select the category "
      {selectedCategory?.category_name}"?
    </DialogContentText>

    {/* Missed Reactive Radio */}
    {/* <Grid container alignItems="center" spacing={2} sx={{ mt: 2 }}>
      <Grid item>Missed Reactive:</Grid>
      <Grid item>
        <RadioGroup
          row
          value={missedReactive}
          onChange={(e) => setMissedReactive(e.target.value)}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
    </Grid> */}
  </DialogContent>

  <DialogActions>
      <Grid item>Missed Reactive:</Grid>
      <Grid item>
        <RadioGroup
          row
          value={missedReactive}
          onChange={(e) => setMissedReactive(e.target.value)}
        >
          <FormControlLabel value="true" control={<Radio />} label="Yes" />
          <FormControlLabel value="false" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
    <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
    <Button
      variant="contained"
      sx={{ backgroundColor: "red !important" }}
      onClick={handleConfirm}
    >
      Confirm
    </Button>
  </DialogActions>
</Dialog>

    </Grid>
  );
};

export default OutletStatus;
